module.exports = __webpack_public_path__ + "static/media/no-picture.0a9d89ac.png";